@if (!passwordResetFunc && !useLocalPasswordChangeModel && [queryData$ | async, persistData$ | async]) {
  <!-- keep async subscriptions alive for normal user settings mode -->
}

@if (res && user) {
  <div class="user-settings-body">
    @if (!errorMessage) {
      <abc-form [formData]="user" labelMode="floating" id="dxForm" (onFieldDataChanged)="onFieldDataChanged($event)">
        @if (allowUserNameChange) {
          <dxi-item itemType="group" [caption]="res.get('UserSettings-MUser')">
            @if (!showActionButtons) {
              <dxi-item>
                <div class="group-label-under-caption">
                  {{ res.get('UserSettings-AccountData') }}
                </div>
              </dxi-item>
            }

            <dxi-item
              [cssClass]="getTextInputClass()"
              dataField="name"
              [editorOptions]="{ valueChangeEvent: 'input', disabled: isPending || isPasswordChanged }"
            >
              <dxo-label [text]="res.get('UserSettings-Name')"></dxo-label>
            </dxi-item>
            <dxi-item
              [cssClass]="getTextInputClass()"
              dataField="email"
              [editorOptions]="{ valueChangeEvent: 'input', disabled: isPending || isPasswordChanged }"
            >
              <dxo-label [text]="res.get('UserSettings-EMail')"></dxo-label>
            </dxi-item>
            <dxi-item
              [cssClass]="getTextInputClass()"
              dataField="login"
              [editorOptions]="{ readOnly: true, disabled: isPending || isPasswordChanged }"
            >
              <dxo-label [text]="res.get('UserSettings-Login')"></dxo-label>
            </dxi-item>
            <dxi-item itemType="empty"></dxi-item>
            @if (showActionButtons) {
              <dxi-item
                [cssClass]="getSubmitButtonClass()"
                itemType="button"
                [buttonOptions]="{
                  text: res.get('UserSettings-Save'),
                  disabled: isPending || !isUserChanged || !isUserValid || isPasswordChanged,
                  onClick: saveUser,
                }"
              >
              </dxi-item>
            }
          </dxi-item>
        }
        @if (allowPasswordChange) {
          <dxi-item itemType="group" [cssClass]="getGroupAuthenticationClass()" [caption]="getAuthenticationCaption()">
            @if (!showActionButtons) {
              <dxi-item itemType="group" cssClass="auth-header">
                <dxi-item>
                  <div *dxTemplate>
                    <!-- This will now correctly show your dynamic caption -->
                    <span class="group-label-under-caption">{{ getAuthenticationCaption() }}</span>
                  </div>
                </dxi-item>
                <dxi-item
                  [cssClass]="getSubmitIconClass()"
                  itemType="button"
                  [buttonOptions]="{
                    icon: res.svgUrl('save-image'),
                    disabled: isPending || !isPasswordValid || isUserChanged,
                    onClick: changePassword,
                  }"
                >
                </dxi-item>
              </dxi-item>
            }

            @if (!passwordResetFunc) {
              <dxi-item
                [cssClass]="getTextInputClass()"
                dataField="password.currentPassword"
                [editorOptions]="{
                  valueChangeEvent: 'input',
                  mode: 'password',
                  inputAttr: { autocomplete: 'new-password' },
                  disabled: isPending || isUserChanged,
                  buttons: currentPasswordTextBoxButton,
                }"
              >
                <dxo-label [text]="res.get('UserSettings-CurrentPW')"></dxo-label>
              </dxi-item>
            }
            <dxi-item
              [cssClass]="getTextInputClass()"
              dataField="password.newPassword"
              [editorOptions]="{
                valueChangeEvent: 'input',
                mode: 'password',
                inputAttr: { autocomplete: 'new-password' },
                disabled: isPending || isUserChanged,
                buttons: newPasswordTextBoxButton,
              }"
            >
              <dxo-label [text]="res.get('UserSettings-NewPW')"></dxo-label>
            </dxi-item>
            <dxi-item
              [cssClass]="getTextInputClass()"
              dataField="password.confirmPassword"
              [editorOptions]="{
                valueChangeEvent: 'input',
                mode: 'password',
                inputAttr: { autocomplete: 'new-password' },
                disabled: isPending || isUserChanged,
                buttons: confirmPasswordTextBoxButton,
                onEnterKey: changePassword,
              }"
            >
              <dxo-label [text]="res.get('UserSettings-ConfirmPW')"></dxo-label>
            </dxi-item>
            <dxi-item itemtype="empty">
              <div class="passwordRequirementsTitle">
                <abc-icon
                  [color]="
                    isNewPasswordValid
                      ? 'var(--success-color, var(--DarkGreenColor))'
                      : 'var(--primary-light-color, var(--PrimaryMainShading10))'
                  "
                  [class]="isNewPasswordValid ? 'success' : 'default'"
                  [svgIcon]="res.svgUrl('check-mark-image')"
                ></abc-icon>
                <p>{{ res.get('UserSettings-PasswordRequirements') }}</p>
              </div>
              <ul class="passwordRequirementsList">
                @for (req of passwordRequirementsWarnings; track req) {
                  <li class="req">{{ req }}</li>
                }
              </ul>
            </dxi-item>

            @if (showActionButtons) {
              <dxi-item
                [cssClass]="getSubmitButtonClass()"
                itemType="button"
                [buttonOptions]="{
                  text: res.get('UserSettings-ChangePassword'),
                  disabled: isPending || !isPasswordValid || isUserChanged,
                  onClick: changePassword,
                }"
              >
              </dxi-item>
            }

            @if (!allowUserNameChange && showActionButtons) {
              <dxi-item
                [cssClass]="getCancelButtonClass()"
                itemType="button"
                [buttonOptions]="{
                  text: res.get('UserSettings-Cancel'),
                  onClick: cancelPasswordChange,
                }"
              >
              </dxi-item>
            }
          </dxi-item>
        }
      </abc-form>
    } @else {
      <div>{{ errorMessage }}</div>
    }
  </div>
}
